export default __webpack_public_path__ + "static/media/5.52432718.PNG";